"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTenantIdCommon = exports.setapplicationMode = exports.getapplicationNumber = exports.lSRemoveItemlocal = exports.lSRemoveItem = exports.localStorageSet = exports.localStorageGet = exports.clearUserDetails = exports.setStoredModulesList = exports.setapplicationNumber = exports.setapplicationType = exports.setReturnUrl = exports.setModule = exports.setLocale = exports.setTenantId = exports.setRefreshToken = exports.setLasttLogin = exports.setDeviceId = exports.setAccessToken = exports.setUserInfoBPA = exports.setUserInfo = exports.getStoredModulesList = exports.getLocalizationLabels = exports.getModuleId = exports.getLocale = exports.setCloseComplaintsCount = exports.getLocalization = exports.getTenantId = exports.getModule = exports.getRole = exports.getDepartmentId = exports.getPGRSector = exports.setPGRSector = exports.getOfficeID = exports.getTpUserInfo = exports.getUserInfo = exports.getHashToken = exports.getAccessToken = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _commons = require("egov-ui-kit/utils/commons");

var _set = require("lodash/set");

var _set2 = _interopRequireDefault(_set);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appName = process.env.REACT_APP_NAME;

//GET methods
var getAccessToken = exports.getAccessToken = function getAccessToken() {
  return localStorageGet("token");
};
var getHashToken = exports.getHashToken = function getHashToken() {
  return localStorageGet("generatedhash");
};
var getUserInfo = exports.getUserInfo = function getUserInfo() {
  return localStorageGet("user-info");
};
var getTpUserInfo = exports.getTpUserInfo = function getTpUserInfo() {
  return localStorageGet("user-info-tp");
};
var getOfficeID = exports.getOfficeID = function getOfficeID() {
  return localStorageGet("officeId");
};
var setPGRSector = exports.setPGRSector = function setPGRSector(locale) {
  localStorageSet("PGRSector", locale);
};
var getPGRSector = exports.getPGRSector = function getPGRSector() {
  return localStorage.getItem("PGRSector");
};
var getDepartmentId = exports.getDepartmentId = function getDepartmentId() {
  return localStorageGet("userDepartmentId");
};
var getRole = exports.getRole = function getRole() {
  return localStorageGet("roleId");
};
var getModule = exports.getModule = function getModule() {
  //   return localStorageGet("moduleId");
  return localStorageGet("module");
};

var getTenantId = exports.getTenantId = function getTenantId() {
  return localStorageGet("tenant-id");
};
var getLocalization = exports.getLocalization = function getLocalization(key) {
  return localStorage.getItem(key);
};
var setCloseComplaintsCount = exports.setCloseComplaintsCount = function setCloseComplaintsCount(Count) {
  localStorageSet("CloseComplaintsCount", Count);
};
var getLocale = exports.getLocale = function getLocale() {
  return localStorage.getItem("locale");
};
var getModuleId = exports.getModuleId = function getModuleId() {
  return localStorage.getItem("module");
};

var getLocalizationLabels = exports.getLocalizationLabels = function getLocalizationLabels() {
  return localStorage.getItem("localization_" + getLocale());
};
var getStoredModulesList = exports.getStoredModulesList = function getStoredModulesList() {
  return localStorage.getItem("storedModulesList");
};

//SET methods
var setUserInfo = exports.setUserInfo = function setUserInfo(userInfo) {
  if (process.env.REACT_APP_NAME == "Citizen") {
    localStorageSet("user-info", userInfo, null);
  } else {
    var userObject = JSON.parse(userInfo) || {};
    userObject.roles = userObject.roles && userObject.roles.filter(function (role) {
      return role.tenantId == userObject.tenantId;
    });
    localStorageSet("user-info", JSON.stringify(userObject), null);
  }
};
var setUserInfoBPA = exports.setUserInfoBPA = function setUserInfoBPA(userInfoBpa, userInfo) {
  if (process.env.REACT_APP_NAME == "Citizen") {
    localStorageSet("user-info-tp", JSON.stringify(userInfoBpa), null);
    //set extra role in common role
    var role = [];
    // role.push({
    //   roles : userInfo.roles
    // })
    role.push({
      code: userInfo.roles[0].code,
      name: userInfo.roles[0].name,
      tenantId: userInfo.roles[0].tenantId
    });
    role.push({
      code: userInfoBpa.lbsArcMaster.lbsArcType,
      name: userInfoBpa.lbsArcMaster.lbsCode,
      tenantId: userInfo.roles[0].tenantId
    });

    (0, _set2.default)(userInfo, 'roles', role);
    localStorageSet("user-info", JSON.stringify(userInfo), null);
  } else {
    // let userObject = JSON.parse(userInfo)||{};
    // userObject.roles=userObject.roles&&userObject.roles.filter(role=>role.tenantId==userObject.tenantId);
    // localStorageSet("user-info-tp", JSON.stringify(userObject), null);
  }
};
var setAccessToken = exports.setAccessToken = function setAccessToken(token) {
  localStorageSet("token", token, null);
};
var setDeviceId = exports.setDeviceId = function setDeviceId(deviceId) {
  localStorageSet("deviceId", deviceId, null);
};
var setLasttLogin = exports.setLasttLogin = function setLasttLogin(lastLogin) {
  localStorageSet("lastLogin", lastLogin, null);
};
var setRefreshToken = exports.setRefreshToken = function setRefreshToken(refreshToken) {
  localStorageSet("refresh-token", refreshToken, null);
};
var setTenantId = exports.setTenantId = function setTenantId(tenantId) {
  localStorageSet("tenant-id", tenantId, null);
  if (process.env.REACT_APP_NAME != "Citizen") {
    //window.sessionStorage.clear();
    Object.keys(window.localStorage).filter(function (key) {
      return key.startsWith('Digit');
    }).map(function (key) {
      return localStorage.removeItem(key);
    });
    var userObj = (0, _commons.getUserSearchedResponse)();
    var user = userObj && userObj.user && userObj.user[0] || {};
    user = (0, _extends3.default)({}, user, { tenantId: tenantId });
    localStorage.setItem("citizen.userRequestObject", JSON.stringify((0, _extends3.default)({}, user)));
    setUserInfo(JSON.stringify((0, _extends3.default)({}, user)));
  }
};
var setLocale = exports.setLocale = function setLocale(locale) {
  localStorageSet("locale", locale);
  localStorage.setItem("locale", locale);
  sessionStorage.setItem("Digit.locale", JSON.stringify({ "value": locale }));
};
var setModule = exports.setModule = function setModule(moduleName) {
  localStorageSet("module", moduleName);
};
var setReturnUrl = exports.setReturnUrl = function setReturnUrl(url) {
  localStorageSet("returnUrl", url);
};
var setapplicationType = exports.setapplicationType = function setapplicationType(applicationTypeName) {
  localStorageSet("applicationType", applicationTypeName);
};

var setapplicationNumber = exports.setapplicationNumber = function setapplicationNumber(applicationNumber) {
  localStorageSet("ApplicationNumber", applicationNumber);
};
var setStoredModulesList = exports.setStoredModulesList = function setStoredModulesList(storedModuleList) {
  localStorage.setItem("storedModulesList", storedModuleList);
};

//Remove Items (LOGOUT)
var clearUserDetails = exports.clearUserDetails = function clearUserDetails() {
  window.localStorage.clear();
  window.sessionStorage.clear();
};
//Role specific get-set Methods
var localStorageGet = exports.localStorageGet = function localStorageGet(key, path) {
  var appName = process.env.REACT_APP_NAME;
  var value = null;
  if (path) {
    var data = JSON.parse(window.localStorage.getItem(appName + "." + key)) || null;
    value = get(data, path);
  } else {
    value = window.localStorage.getItem(appName + "." + key) || null;
  }
  return value;
};
var localStorageSet = exports.localStorageSet = function localStorageSet(key, data, path) {
  var appName = process.env.REACT_APP_NAME;
  var storedData = window.localStorage.getItem(appName + "." + key);

  if (path) {
    (0, _set2.default)(storedData, path, data);
    window.localStorage.setItem(appName + "." + key, storedData);
    window.localStorage.setItem(key, storedData);
  } else {
    window.localStorage.setItem(appName + "." + key, data);
    window.localStorage.setItem(key, data);
  }
};
//Remove Item
var lSRemoveItem = exports.lSRemoveItem = function lSRemoveItem(key) {
  var appName = process.env.REACT_APP_NAME;
  window.localStorage.removeItem(appName + "." + key);
};

var lSRemoveItemlocal = exports.lSRemoveItemlocal = function lSRemoveItemlocal(key) {
  window.localStorage.removeItem(key);
};
var getapplicationNumber = exports.getapplicationNumber = function getapplicationNumber() {
  return localStorage.getItem("ApplicationNumber");
};

var setapplicationMode = exports.setapplicationMode = function setapplicationMode(applicationMode) {
  localStorageSet("applicationMode", applicationMode);
};
// get tenantId for Employee/Citizen
var getTenantIdCommon = exports.getTenantIdCommon = function getTenantIdCommon() {
  return process.env.REACT_APP_NAME === "Citizen" ? JSON.parse(getUserInfo()).permanentCity : getTenantId();
};


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/utils/localStorageUtils/index.js
// module id = 20
// module chunks = 1137